export default __webpack_public_path__ + "cf667aa14a549aa67cff2a4007f182e5.png";